import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'setMinimumDurationConverter'
})
export class SetMinimumDurationConverterPipe implements PipeTransform {
  transform(value: number): number {
    return Math.max(value, 60);
  }
}